




























import { getCookie, setCookie } from 'tiny-cookie'
import moment from 'moment'

export default {
  data() {
    return {
      show: false,
      expirationDate: moment('01/01/2022', 'DD/MM/YYYY'),
      startDate: moment('05/01/2021', 'DD/MM/YYYY')
    }
  },
  mounted() {
    const isExpired = moment().isAfter(this.expirationDate)
    const isNotStarted = moment().isBefore(this.startDate)
    const hasCookie = getCookie('seenInformationDialog')

    if (hasCookie || isExpired || isNotStarted) return
    this.show = true
    this.setImprovementCookie()
  },
  methods: {
    closeDialog(): void {
      this.show = false
    },
    handleConfirmClick(): void {
      this.closeDialog()
      this.$emit('confirm')
    },
    setImprovementCookie(): void {
      const expires = this.expirationDate.format()
      setCookie('seenInformationDialog', 'true', { expires })
    }
  }
}
